var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndicatorArc01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 331.2 331.2",
    style: {
      enableBackground: "new 0 0 331.2 331.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st13{fill:#999999;opacity:0.5}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M331.9,156.5c-1.4-26-9-51.7-22-74.3c-13-22.6-31.5-42-53.4-56.2C234.6,11.7,209.3,2.7,183.4,0 c-2.1-0.2-4,1.3-4.2,3.4c-0.2,2.1,1.3,4,3.4,4.2c24.7,2.6,48.9,11.1,69.7,24.7c20.9,13.6,38.5,32.1,50.9,53.7 c12.4,21.5,19.7,46.1,21,70.9c1.3,24.9-3.4,50-13.5,72.7c-0.9,1.9,0,4.2,1.9,5c0.5,0.2,1,0.3,1.5,0.3c1.5,0,2.9-0.8,3.5-2.3 C328.3,208.9,333.2,182.5,331.9,156.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M299.1,258c-1.7-1.2-4.1-0.9-5.3,0.8c-14.7,20.1-34.2,36.6-56.5,47.8c-22.2,11.2-47.1,17.1-72,17 c-24.9-0.1-49.7-6.2-71.8-17.6c-22.1-11.4-41.5-28.1-56-48.3c-1.2-1.7-3.6-2.1-5.3-0.9c-1.7,1.2-2.1,3.6-0.9,5.3 c15.2,21.2,35.5,38.7,58.7,50.6c23.2,11.9,49.2,18.3,75.3,18.4c0.2,0,0.5,0,0.7,0c25.8,0,51.7-6.1,74.8-17.8 c23.3-11.7,43.8-29.1,59.2-50.1C301.2,261.7,300.8,259.3,299.1,258z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M28.8,85.9c12.4-21.5,30-40.1,50.9-53.7c20.9-13.6,45-22.1,69.7-24.7c2.1-0.2,3.6-2.1,3.4-4.2 c-0.2-2.1-2.1-3.6-4.2-3.4c-25.9,2.7-51.2,11.7-73.1,25.9C53.7,40.1,35.3,59.6,22.2,82.1c-13,22.6-20.7,48.3-22,74.3 c-1.4,26,3.5,52.4,14.1,76.2c0.6,1.4,2,2.3,3.5,2.3c0.5,0,1-0.1,1.5-0.3c1.9-0.9,2.8-3.1,1.9-5c-10.1-22.7-14.8-47.9-13.5-72.7 C9.1,132,16.4,107.5,28.8,85.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicatorArc01);
export default __webpack_public_path__ + "static/media/indicator_arc-01.7a982f18602e29e07cd8423c7a905ce7.svg";
export { ForwardRef as ReactComponent };